import { html } from 'lit-html';
import { AddRecommendationItemJsEnv } from '../models/add_recommendation_item_js_env';
import { AddRecommendationItemAction } from '../actions/add_recommendation_item_action';

export const FolderName = (model: AddRecommendationItemJsEnv) => html`
  <dt class="a-formHead">
    <div class="o-colBox -jcbetween -aicenter">
      <label for="foldername04" class="a-label">フォルダ名</label>
      <span class="a-tag -bgRed">必須</span>
    </div>
  </dt>
  <dd class="a-formBody">
    <div class="o-colBox -aicenter -margin24">
      <div class="a-formBody_inner">
        <div class="a-textinput js-input">
          <span class="a-textinput_inputwrap">
            <input type="text" class="a-textinput_input" id="foldername04" maxlength="20"
             @input="${() => AddRecommendationItemAction.checkTextMargin()}"
            >
          </span>
        </div>
      </div>
      <p class="a-text">残り${model.marginCount}文字</p>
    </div>
  </dd>
`;
